// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"ArticleListSection_titleContainer__HJ6MC","articles":"ArticleListSection_articles__hKDc4"};